import React from 'react';
import {
  FaArrowLeft, FaStar, FaGift, FaUsers, FaShareAlt, FaAward, FaTrophy,
  FaRocket, FaCrown, FaGlobe, FaHiking, FaCompass, FaChevronRight
} from 'react-icons/fa';

const TIERS = [
  { id: 'explorer', name: 'Explorer', min: 0, max: 999, icon: '🌱', color: '#6B7280', bg: '#F3F4F6' },
  { id: 'navigator', name: 'Navigator', min: 1000, max: 4999, icon: '🧭', color: '#3B82F6', bg: '#EFF6FF' },
  { id: 'adventurer', name: 'Adventurer', min: 5000, max: 14999, icon: '🏔', color: '#8B5CF6', bg: '#F5F3FF' },
  { id: 'globetrotter', name: 'Globetrotter', min: 15000, max: 49999, icon: '🌏', color: '#F59E0B', bg: '#FFFBEB' },
  { id: 'ambassador', name: 'Ambassador', min: 50000, max: null, icon: '⭐', color: '#EF4444', bg: '#FEF2F2' },
];

const CATALOG = [
  { name: '1 Month Solo', points: 800, value: '$7.99' },
  { name: '1 Month Group', points: 1500, value: '$14.99' },
  { name: 'Upgrade Solo to Group (1 month)', points: 700, value: '$7.00' },
  { name: '1 Year Solo', points: 6000, value: '$29.95' },
  { name: '1 Year Group', points: 8000, value: '$79.99' },
];

const RewardsPage = ({ onBack }) => {
  return (
    <div style={{ maxWidth: '900px', margin: '0 auto', padding: '32px 16px' }}>
      {/* Header */}
      {onBack && (
        <button
          onClick={onBack}
          style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#6B7280', background: 'none', border: 'none', cursor: 'pointer', marginBottom: '24px', fontSize: '15px' }}
        >
          <FaArrowLeft /> Back
        </button>
      )}

      <div style={{ textAlign: 'center', marginBottom: '48px' }}>
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
          <FaStar style={{ color: '#F59E0B', fontSize: '32px' }} />
          <h1 style={{ fontSize: '36px', fontWeight: '800', color: '#1F2937', margin: 0 }}>Travel Points</h1>
        </div>
        <p style={{ color: '#6B7280', fontSize: '18px', maxWidth: '600px', margin: '0 auto' }}>
          Earn points by referring friends and use them for free subscriptions. Every trip counts.
        </p>
      </div>

      {/* How It Works */}
      <section style={{ marginBottom: '48px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1F2937', marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <FaRocket style={{ color: '#877B98' }} /> How It Works
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '20px' }}>
          <div style={{ background: '#F9FAFB', borderRadius: '12px', padding: '24px', textAlign: 'center' }}>
            <FaShareAlt style={{ fontSize: '28px', color: '#877B98', marginBottom: '12px' }} />
            <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#1F2937', marginBottom: '8px' }}>1. Share Your Referral Link</h3>
            <p style={{ color: '#6B7280', fontSize: '14px', margin: 0 }}>Send your unique referral link to friends and family who love to travel.</p>
          </div>
          <div style={{ background: '#F9FAFB', borderRadius: '12px', padding: '24px', textAlign: 'center' }}>
            <FaUsers style={{ fontSize: '28px', color: '#10B981', marginBottom: '12px' }} />
            <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#1F2937', marginBottom: '8px' }}>2. Friends Sign Up</h3>
            <p style={{ color: '#6B7280', fontSize: '14px', margin: 0 }}>When they create an account, you earn <strong>+100</strong> points instantly.</p>
          </div>
          <div style={{ background: '#F9FAFB', borderRadius: '12px', padding: '24px', textAlign: 'center' }}>
            <FaGift style={{ fontSize: '28px', color: '#F59E0B', marginBottom: '12px' }} />
            <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#1F2937', marginBottom: '8px' }}>3. Claim Your Perks</h3>
            <p style={{ color: '#6B7280', fontSize: '14px', margin: 0 }}>Use your points toward free subscriptions from the catalog below.</p>
          </div>
        </div>
      </section>

      {/* Referral Flow */}
      <section style={{ marginBottom: '48px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1F2937', marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <FaShareAlt style={{ color: '#10B981' }} /> Referral Flow
        </h2>
        <div style={{ background: 'linear-gradient(135deg, #ECFDF5, #F0FDF4)', borderRadius: '12px', padding: '28px', border: '1px solid #D1FAE5' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
              <div style={{ background: '#10B981', color: 'white', borderRadius: '50%', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '700', flexShrink: 0 }}>1</div>
              <div>
                <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#1F2937', margin: '0 0 4px 0' }}>Friend Signs Up</h3>
                <p style={{ color: '#374151', fontSize: '14px', margin: 0 }}>
                  Your friend creates an account using your referral link. You earn <strong style={{ color: '#10B981' }}>+100 points</strong> immediately.
                </p>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
              <div style={{ background: '#F59E0B', color: 'white', borderRadius: '50%', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '700', flexShrink: 0 }}>2</div>
              <div>
                <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#1F2937', margin: '0 0 4px 0' }}>Friend Subscribes to a Paid Plan</h3>
                <p style={{ color: '#374151', fontSize: '14px', margin: 0 }}>
                  When your friend maintains a paid subscription for at least <strong>30 days</strong>, you earn: <strong style={{ color: '#F59E0B' }}>+500</strong> for Solo, <strong style={{ color: '#F59E0B' }}>+750</strong> for Group, plus <strong style={{ color: '#F59E0B' }}>+1,000 bonus</strong> if they choose yearly billing.
                </p>
              </div>
            </div>
          </div>
          <div style={{ marginTop: '20px', padding: '16px', background: 'white', borderRadius: '8px', border: '1px solid #D1FAE5' }}>
            <p style={{ color: '#374151', fontSize: '14px', margin: 0 }}>
              <strong>Total per referral:</strong> Up to <strong style={{ color: '#059669' }}>1,850 points</strong> — +100 signup, +500–750 based on plan, +1,000 yearly billing bonus.
            </p>
          </div>
        </div>
      </section>

      {/* Membership Tiers */}
      <section style={{ marginBottom: '48px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1F2937', marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <FaTrophy style={{ color: '#F59E0B' }} /> Membership Tiers
        </h2>
        <p style={{ color: '#6B7280', fontSize: '14px', marginBottom: '20px' }}>
          Based on your lifetime points earned, these are display-only status badges to showcase your engagement.
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {TIERS.map((tier) => (
            <div key={tier.id} style={{
              display: 'flex', alignItems: 'center', gap: '16px',
              background: tier.bg, borderRadius: '10px', padding: '16px 20px',
              border: `1px solid ${tier.color}22`
            }}>
              <span style={{ fontSize: '28px' }}>{tier.icon}</span>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: '600', color: '#1F2937', fontSize: '16px' }}>{tier.name}</div>
                <div style={{ color: '#6B7280', fontSize: '13px' }}>
                  {tier.max
                    ? `${tier.min.toLocaleString()} – ${tier.max.toLocaleString()} lifetime points`
                    : `${tier.min.toLocaleString()}+ lifetime points`}
                </div>
              </div>
              <div style={{ color: tier.color, fontWeight: '700', fontSize: '14px' }}>
                {tier.min === 0 ? 'Starting Tier' : `${tier.min.toLocaleString()} pts`}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Points Catalog */}
      <section style={{ marginBottom: '48px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1F2937', marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <FaGift style={{ color: '#877B98' }} /> Points Catalog
        </h2>
        <p style={{ color: '#6B7280', fontSize: '14px', marginBottom: '20px' }}>
          Redeem your points for free subscription time. All items are applied instantly to your account.
        </p>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
            <thead>
              <tr style={{ background: '#F9FAFB', textAlign: 'left' }}>
                <th style={{ padding: '12px 16px', fontWeight: '600', color: '#374151', borderBottom: '2px solid #E5E7EB' }}>Reward</th>
                <th style={{ padding: '12px 16px', fontWeight: '600', color: '#374151', borderBottom: '2px solid #E5E7EB', textAlign: 'center' }}>Points</th>
                <th style={{ padding: '12px 16px', fontWeight: '600', color: '#374151', borderBottom: '2px solid #E5E7EB', textAlign: 'center' }}>Value</th>
              </tr>
            </thead>
            <tbody>
              {CATALOG.map((item, idx) => (
                <tr key={idx} style={{ borderBottom: '1px solid #E5E7EB' }}>
                  <td style={{ padding: '12px 16px', color: '#1F2937' }}>{item.name}</td>
                  <td style={{ padding: '12px 16px', textAlign: 'center', fontWeight: '600', color: '#877B98' }}>
                    {item.points.toLocaleString()}
                  </td>
                  <td style={{ padding: '12px 16px', textAlign: 'center', color: '#6B7280' }}>{item.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* Rules */}
      <section style={{ marginBottom: '48px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1F2937', marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <FaAward style={{ color: '#6B7280' }} /> Rules
        </h2>
        <div style={{ background: '#F9FAFB', borderRadius: '12px', padding: '24px' }}>
          <ul style={{ margin: 0, padding: '0 0 0 20px', display: 'flex', flexDirection: 'column', gap: '12px', color: '#374151', fontSize: '14px', lineHeight: '1.6' }}>
            <li>You cannot refer yourself — self-referral is not allowed.</li>
            <li>Each person can only be referred once. Duplicate referrals are not counted.</li>
            <li>Points <strong>never expire</strong> — your balance is yours to keep.</li>
            <li>The <strong>+500 upgrade bonus</strong> requires the referred friend to maintain a paid plan for at least <strong>30 days</strong> continuously. The 30-day requirement ensures genuine engagement.</li>
            <li>If the referred friend <strong>downgrades</strong> before the 30-day period, the upgrade reward is forfeited.</li>
            <li>There is a monthly cap of <strong>2,000 points</strong> from referrals.</li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default RewardsPage;
